/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : CTA : ORGANIZE CONTENT : STYLES --------------- ++++++++++ */
export default theme => ({
	organizecontent: {
		fontSize: pxToEm(12)
	}
});
